import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import SearchWithFreeTextAPI from "../common/searchbox-free-text";
import { Row, Col } from "react-bootstrap";



export default function CommonFilter({ type, onSubmit, open, onClose }) {

  const apiUrl = process.env.REACT_APP_API_URL;
  const adminAPIUrl = process.env.REACT_APP_ADMIN_API_URL;

  const fieldConfig = {
    leads: {
      leadname: true,
      company: true,
      email: true,
      phone: true,
      leadsource: true,
      leadstatus: true,
      industry: true,
      leadowner: true
    },
    calls: { calltype: true, callfor: true },
    payment: { customer: true, paymenttype: true },
    contacts: {
      contactname: true,
      companyname: true,
      contactphone: true,
      contactemail: true,
      status: true,
      contactsource: true,
      contactindustry: true
    },
    accounts: {
      accountname: true,
      accountphone: true,
      website: true,
      accountowner: true,
      accountindustry: true,
      accountstatus: true
    }
  };

  const isEnabled = fieldConfig[type];
  const [isResetting, setIsResetting] = useState(false);


  const [leadSource, setLeadSource] = useState("");
  const [callType, setCallType] = useState("");
  const [callFor, setCallFor] = useState("");
  const [leadStatus, setLeadStatus] = useState("");
  const [industry, setIndustry] = useState("");
  const [leadOwner, setLeadOwner] = useState("");
  const [leadOwnerId, setLeadOwnerId] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [paymentTypeId, setPaymentTypeId] = useState("");
  const [contactSource, setContactSource] = useState("");
  const [contactIndustry, setContactIndustry] = useState("");

  // New States for table header filtering
  const [leadName, setLeadName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [contactName, setContactName] = useState("");
  const [contactCompanyName, setContactCompanyName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactStatus, setContactStatus] = useState("");
  const [contactFromDate, setContactFromDate] = useState("");
  const [contactToDate, setContactToDate] = useState("");

  const [accountName, setAccountName] = useState("");
  const [accountPhone, setAccountPhone] = useState("");
  const [accountWebsite, setAccountWebsite] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [accountOwner, setAccountOwner] = useState("");
  const [accountOwnerId, setAccountOwnerId] = useState(0);
  const [accountIndustryName, setAccountIndustryName] = useState("");
  const [accountIndustryId, setAccountIndustryId] = useState("");

  const handleReset = () => {
    setLeadSource("");
    setLeadStatus("");
    setIndustry("");
    setLeadOwner("");
    setLeadOwnerId("");
    setCustomer("");
    setCustomerId("");
    setPaymentType("");
    setPaymentTypeId("");
    setContactSource("");
    setContactIndustry("");
    setLeadName("");
    setCompany("");
    setEmail("");
    setPhone("");
    setContactName("");
    setContactCompanyName("");
    setContactPhone("");
    setContactEmail("");
    setContactStatus("");
    setContactFromDate("");
    setContactToDate("");
    setAccountName("");
    setAccountPhone("");
    setAccountWebsite("");
    setAccountStatus("");
    setAccountOwner("");
    setAccountOwnerId("");
    setAccountIndustryName("");
    setAccountIndustryId("");
    setCallType("");
    setCallFor("");
    setIsResetting(true);
  }

  useEffect(() => {
    if (isResetting) {
      handleSubmit();
      setIsResetting(false);
    }
  }, [
    leadSource, leadStatus, industry, leadOwner, customer, paymentType,
    contactSource, contactIndustry, leadName, company, email, phone,
    contactName, contactCompanyName, contactPhone, contactEmail, contactStatus,
    contactFromDate, contactToDate,
    accountName, accountPhone, accountWebsite, accountStatus, accountOwner, accountIndustryName,
    callType, callFor
  ]);


  const handleSubmit = () => {
    let finalFilters = "";
    if (type === "payment") {
      let parts = [];
      if (customerId) parts.push("customer_id=" + encodeURIComponent(customerId));
      if (paymentTypeId) parts.push("payment_type_id=" + encodeURIComponent(paymentTypeId));
      finalFilters = parts.length > 0 ? "&" + parts.join("&") : "";
    } else if (type === "contacts") {
      let parts = [];
      if (contactSource) parts.push("lead_source=" + encodeURIComponent(contactSource));
      if (contactIndustry) parts.push("industry_type=" + encodeURIComponent(contactIndustry));
      if (contactName) parts.push("name=" + encodeURIComponent(contactName));
      if (contactCompanyName) parts.push("company_name=" + encodeURIComponent(contactCompanyName));
      if (contactPhone) parts.push("phone=" + encodeURIComponent(contactPhone));
      if (contactEmail) parts.push("email=" + encodeURIComponent(contactEmail));
      if (contactStatus !== "") parts.push("status=" + encodeURIComponent(contactStatus));
      if (contactFromDate) parts.push("from_date=" + encodeURIComponent(contactFromDate));
      if (contactToDate) parts.push("to_date=" + encodeURIComponent(contactToDate));
      finalFilters = parts.length > 0 ? "&" + parts.join("&") : "";
    } else if (type === "accounts") {
      let parts = [];
      if (accountName) parts.push("name=" + encodeURIComponent(accountName));
      if (accountPhone) parts.push("phone=" + encodeURIComponent(accountPhone));
      if (accountWebsite) parts.push("website=" + encodeURIComponent(accountWebsite));
      if (accountIndustryId) parts.push("industry_id=" + encodeURIComponent(accountIndustryId));
      if (accountOwnerId) parts.push("account_owner_id=" + encodeURIComponent(accountOwnerId));
      if (accountStatus !== "") parts.push("status=" + encodeURIComponent(accountStatus));
      finalFilters = parts.length > 0 ? "&" + parts.join("&") : "";
    } else if (type === "calls") {
      let parts = [];
      if (callType) parts.push("call_type=" + encodeURIComponent(callType));
      if (callFor) parts.push("call_for=" + encodeURIComponent(callFor));
      finalFilters = parts.length > 0 ? "&" + parts.join("&") : "";
    } else {
      let parts = [];
      if (leadSource) parts.push("lead_source=" + encodeURIComponent(leadSource));
      if (leadStatus) parts.push("lead_status=" + encodeURIComponent(leadStatus));
      if (industry) parts.push("industry=" + encodeURIComponent(industry));
      if (leadOwnerId) parts.push("lead_owner_id=" + encodeURIComponent(leadOwnerId));
      if (leadName) parts.push("name=" + encodeURIComponent(leadName));
      if (company) parts.push("company=" + encodeURIComponent(company));
      if (email) parts.push("email=" + encodeURIComponent(email));
      if (phone) parts.push("phone=" + encodeURIComponent(phone));
      finalFilters = parts.length > 0 ? "&" + parts.join("&") : "";
    }
    onSubmit(finalFilters, type);
    onClose();
  };


  // Lead Source
  const handleLeadSourceDropdownChange = (option) => {
    setLeadSource(option?.label || "");
  };

  const handleLeadSourceOnChange = (term) => {
    setLeadSource(term);
  };

  // Lead Status
  const handleLeadStatusDropdownChange = (option) => {
    setLeadStatus(option?.label || "");
  };

  const handleLeadStatusOnChange = (term) => {
    setLeadStatus(term);
  };

  // Industry
  const handleIndustryDropdownChange = (option) => {
    setIndustry(option?.label || "");
  };

  const handleIndustryOnChange = (term) => {
    setIndustry(term);
  };

  // Lead Owner
  const handleLeadOwnerDropdownChange = (option) => {
    setLeadOwner(option?.label || "");
    setLeadOwnerId(option?.value || "");
  };

  const handleLeadOwnerOnChange = (term) => {
    setLeadOwner(term);
    setLeadOwnerId("");
  };

  // Customer (for payments)
  const handleCustomerDropdownChange = (option) => {
    setCustomer(option?.label || "");
    setCustomerId(option?.value || "");
  };

  const handleCustomerOnChange = (term) => {
    setCustomer(term);
    setCustomerId("");
  };

  // Payment Type (for payments)
  const handlePaymentTypeDropdownChange = (option) => {
    setPaymentType(option?.label || "");
    setPaymentTypeId(option?.value || "");
  };

  const handlePaymentTypeOnChange = (term) => {
    setPaymentType(term);
    setPaymentTypeId("");
  };

  // Contact Source
  const handleContactSourceDropdownChange = (option) => {
    setContactSource(option?.label || "");
  };

  const handleContactSourceOnChange = (term) => {
    setContactSource(term);
  };

  // Contact Industry
  const handleContactIndustryDropdownChange = (option) => {
    setContactIndustry(option?.label || "");
  };

  const handleContactIndustryOnChange = (term) => {
    setContactIndustry(term);
  };

  // Account Owner
  const handleAccountOwnerDropdownChange = (option) => {
    setAccountOwner(option?.label || "");
    setAccountOwnerId(option?.value || "");
  };

  const handleAccountOwnerOnChange = (term) => {
    setAccountOwner(term);
    setAccountOwnerId("");
  };

  // Account Industry
  const handleAccountIndustryDropdownChange = (option) => {
    setAccountIndustryName(option?.label || "");
    setAccountIndustryId(option?.value || "");
  };

  const handleAccountIndustryOnChange = (term) => {
    setAccountIndustryName(term);
    setAccountIndustryId("");
  };

  return (
    <>
      {/* ✅ INTERNAL CSS */}
      <style>
        {`
        .filter-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          z-index: 999;
          display: flex;
          justify-content: flex-end;
          pointer-events: ${open ? "auto" : "none"};
          opacity: ${open ? "1" : "0"};
          transition: opacity 0.3s ease;
        }

        .filter-box {
          width: 340px;
          height: 100vh;
          background: white;
          transform: translateX(${open ? "0" : "100%"});
          transition: transform 0.35s ease-in-out;
          box-shadow: -3px 0 12px rgba(0,0,0,0.25);
          display: flex;
          flex-direction: column;
        }

        .filter-header {
          background: #F8F9F9;
          height: 53px;
          padding: 10px 15px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .filter-body {
          flex: 1;
          overflow-y: auto;
          padding: 20px;
        }

        .filter-footer {
          padding: 15px;
          border-top: 1px solid #ddd;
          flex-shrink: 0;
          background-color:#F8F9F9;
          margin-top: 12px;
          margin-bottom: 12px;
        }

        .filter-btn {
          padding: 10px 32px;
          text-align: center;
          cursor: pointer;
          border-radius: 45px;
          font-weight: 700;
          font-size: 16px;
        }

        .close-btn {
          cursor: pointer;
          font-size: 18px;
        }
        `}
      </style>

      {/* ✅ OVERLAY */}
      {ReactDOM.createPortal(
      <div className="filter-overlay" onClick={onClose}>
        <div className="filter-box" onClick={(e) => e.stopPropagation()}>

          {/* ✅ HEADER */}
          <div className="filter-header">
            <p style={{ fontWeight: "700", fontSize: "20px", color: "#212129", margin: 0 }}>
              Filters
            </p>
            <span className="close-btn" onClick={onClose}>✖</span>
          </div>

          {/* ✅ SCROLLABLE CONTENT */}
          <div className="filter-body">

            {/* Leads specific table headers filters */}
            {isEnabled?.leadname && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div>Lead Name</div>
                <input
                  type="text"
                  placeholder="Search Lead Name"
                  value={leadName}
                  onChange={(e) => setLeadName(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.company && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Company</div>
                <input
                  type="text"
                  placeholder="Search Company"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.email && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Email</div>
                <input
                  type="text"
                  placeholder="Search Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.phone && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Phone number</div>
                <input
                  type="text"
                  placeholder="Search Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {/* Contacts specific table headers filters */}
            {isEnabled?.contactname && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div>Contact Name</div>
                <input
                  type="text"
                  placeholder="Search Contact Name"
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.companyname && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Company Name</div>
                <input
                  type="text"
                  placeholder="Search Company Name"
                  value={contactCompanyName}
                  onChange={(e) => setContactCompanyName(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.contactphone && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Phone number</div>
                <input
                  type="text"
                  placeholder="Search Phone number"
                  value={contactPhone}
                  onChange={(e) => setContactPhone(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.contactemail && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Email</div>
                <input
                  type="text"
                  placeholder="Search Email"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.status && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Status</div>
                <select
                  value={contactStatus}
                  onChange={(e) => setContactStatus(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">Select Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            )}

            {type === "contacts" && (
              <>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                  <div>From Date</div>
                  <input
                    type="date"
                    className="form-control"
                    value={contactFromDate}
                    onChange={(e) => setContactFromDate(e.target.value)}
                    style={{
                      width: "100%",
                      height: "38px",
                      borderRadius: "8px",
                      border: "1px solid #E5E5E5",
                      padding: "8px 12px",
                      fontSize: "14px",
                      outline: "none",
                      backgroundColor: "white",
                    }}
                  />
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                  <div>To Date</div>
                  <input
                    type="date"
                    className="form-control"
                    value={contactToDate}
                    min={contactFromDate || undefined}
                    onChange={(e) => setContactToDate(e.target.value)}
                    style={{
                      width: "100%",
                      height: "38px",
                      borderRadius: "8px",
                      border: "1px solid #E5E5E5",
                      padding: "8px 12px",
                      fontSize: "14px",
                      outline: "none",
                      backgroundColor: "white",
                    }}
                  />
                </div>
              </>
            )}

            {/* Existing source, status, industry filters */}
            {isEnabled?.accountname && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div>Account Name</div>
                <input
                  type="text"
                  placeholder="Search Account Name"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.accountphone && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Phone number</div>
                <input
                  type="text"
                  placeholder="Search Phone number"
                  value={accountPhone}
                  onChange={(e) => setAccountPhone(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.website && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Website</div>
                <input
                  type="text"
                  placeholder="Search Website"
                  value={accountWebsite}
                  onChange={(e) => setAccountWebsite(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              </div>
            )}

            {isEnabled?.accountowner && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Account owner</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleAccountOwnerDropdownChange}
                  onChangeSearch={handleAccountOwnerOnChange}
                  apiUrl={adminAPIUrl + `get_employee`}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Employee"}
                  selectedValue={accountOwner}
                />
              </div>
            )}

            {isEnabled?.accountindustry && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Industry</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleAccountIndustryDropdownChange}
                  onChangeSearch={handleAccountIndustryOnChange}
                  apiUrl={apiUrl + "industry_type"}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Industry"}
                  selectedValue={accountIndustryName}
                />
              </div>
            )}

            {isEnabled?.accountstatus && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Status</div>
                <select
                  value={accountStatus}
                  onChange={(e) => setAccountStatus(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">Select Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            )}

            {isEnabled?.leadsource && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Lead Source</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleLeadSourceDropdownChange}
                  onChangeSearch={handleLeadSourceOnChange}
                  apiUrl={apiUrl + "lead/leadsource_autosuggestion"}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Lead Source"}
                  selectedValue={leadSource}
                />
              </div>
            )}

            {isEnabled?.leadstatus && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Lead Status</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleLeadStatusDropdownChange}
                  onChangeSearch={handleLeadStatusOnChange}
                  apiUrl={apiUrl + `lead/leadstatus_autosuggestion`}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Lead Status"}
                  selectedValue={leadStatus}
                />
              </div>
            )}

            {isEnabled?.industry && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Industry</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleIndustryDropdownChange}
                  onChangeSearch={handleIndustryOnChange}
                  apiUrl={apiUrl + "lead/industry_autosuggestion"}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Industry"}
                  selectedValue={industry}
                />
              </div>
            )}

            {isEnabled?.contactsource && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Source</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleContactSourceDropdownChange}
                  onChangeSearch={handleContactSourceOnChange}
                  apiUrl={apiUrl + "contact/leadsource_autosuggestion"}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Source"}
                  selectedValue={contactSource}
                />
              </div>
            )}

            {isEnabled?.contactindustry && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Industry Type</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleContactIndustryDropdownChange}
                  onChangeSearch={handleContactIndustryOnChange}
                  apiUrl={apiUrl + "contact/industry_autosuggestion"}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Industry Type"}
                  selectedValue={contactIndustry}
                />
              </div>
            )}

            {isEnabled?.leadowner && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div>Lead owner</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleLeadOwnerDropdownChange}
                  onChangeSearch={handleLeadOwnerOnChange}
                  apiUrl={adminAPIUrl + `get_employee`}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Employee"}
                  selectedValue={leadOwner}
                />
              </div>
            )}

            {isEnabled?.customer && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }}>Customer</div>
                <SearchWithFreeTextAPI
                  onDropdownChange={handleCustomerDropdownChange}
                  onChangeSearch={handleCustomerOnChange}
                  apiUrl={apiUrl + `get_customers`}
                  params={{}}
                  searchLimit={0}
                  placeholder={"Search Customer"}
                  selectedValue={customer}
                />
              </div>
            )}

            {isEnabled?.paymenttype && (
               <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                 <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }}>Payment Mode</div>
                 <SearchWithFreeTextAPI
                   onDropdownChange={handlePaymentTypeDropdownChange}
                   onChangeSearch={handlePaymentTypeOnChange}
                   apiUrl={apiUrl + `get_payment_type`}
                   params={{}}
                   searchLimit={0}
                   placeholder={"Search Payment Mode"}
                   selectedValue={paymentType}
                 />
               </div>
             )}

            {isEnabled?.calltype && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }}>Call Type</div>
                <select
                  value={callType}
                  onChange={(e) => setCallType(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">Select Call Type</option>
                  <option value="Inbound Call">Inbound Call</option>
                  <option value="Outbound Call">Outbound Call</option>
                  <option value="Follow-up Call">Follow-up Call</option>
                  <option value="Sales Call">Sales Call</option>
                  <option value="Support Call">Support Call</option>
                  <option value="Service Call">Service Call</option>
                  <option value="Cold Call">Cold Call</option>
                  <option value="Warm Call">Warm Call</option>
                  <option value="Demo Call">Demo Call</option>
                  <option value="Presentation Call">Presentation Call</option>
                  <option value="Feedback Call">Feedback Call</option>
                  <option value="Welcome Call">Welcome Call</option>
                  <option value="Onboarding Call">Onboarding Call</option>
                  <option value="Reminder Call">Reminder Call</option>
                  <option value="Escalation Call">Escalation Call</option>
                </select>
              </div>
            )}

            {isEnabled?.callfor && (
              <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "15px" }}>
                <div style={{ fontWeight: "500", fontSize: "14px", color: "#172b4d" }}>Call For</div>
                <select
                  value={callFor}
                  onChange={(e) => setCallFor(e.target.value)}
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E5E5",
                    padding: "8px 12px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "white"
                  }}
                >
                  <option value="">Select Call For</option>
                  <option value="Lead">Lead</option>
                </select>
              </div>
            )}


          </div>

          {/* ✅ FIXED BOTTOM APPLY BUTTON */}
          <div className="filter-footer">

            <Row className="align-items-center justify-content-between" style={{ width: "100%" }}>

              <Col sm={12} md={6} lg={6}>
                <div className="filter-btn" style={{ backgroundColor: "white", color: "black", border: '1px solid #E5E5E5' }} onClick={handleReset}>
                  Reset
                </div>
              </Col>
              <Col sm={12} md={6} lg={6}>
                <div className="filter-btn" style={{ backgroundColor: '#3D4AF5', color: "white" }} onClick={handleSubmit}>
                  Apply
                </div>
              </Col>
            </Row>

          </div>
        </div>
      </div>, document.body)}
    </>
  );
}
